import type { JSX } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { ApplicationStatus } from '../../types/jobPositionCandidate.types';
import {
  APPLICATION_STATUS_CONFIG,
  VALID_STATUS_TRANSITIONS,
} from '../../types/jobPositionCandidate.types';
import { ApplicationStatusBadge } from './ApplicationStatusBadge';

interface ApplicationStatusSelectProps {
  currentStatus: ApplicationStatus;
  onStatusChange: (newStatus: ApplicationStatus) => void;
  disabled?: boolean;
}

export function ApplicationStatusSelect({
  currentStatus,
  onStatusChange,
  disabled = false,
}: ApplicationStatusSelectProps): JSX.Element {
  const allowedTransitions = VALID_STATUS_TRANSITIONS[currentStatus];

  // If no transitions are allowed (terminal state), just show the badge
  if (allowedTransitions.length === 0) {
    return <ApplicationStatusBadge status={currentStatus} />;
  }

  return (
    <Select
      value={currentStatus}
      onValueChange={(value) => onStatusChange(value as ApplicationStatus)}
      disabled={disabled}
    >
      <SelectTrigger className="w-[140px] h-8">
        <SelectValue>
          <ApplicationStatusBadge status={currentStatus} />
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {/* Current status is always shown */}
        <SelectItem value={currentStatus}>
          {APPLICATION_STATUS_CONFIG[currentStatus].label}
        </SelectItem>
        {/* Show allowed transitions */}
        {allowedTransitions.map((status) => (
          <SelectItem key={status} value={status}>
            {APPLICATION_STATUS_CONFIG[status].label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
